import { Employee } from '../../services/Employee';

const identityItem = {
    organization: '',
    role: '',
    firstName: '',
    lastName: ''
};

function initialState() {
    return {
        item: identityItem,
        loading: false,
    }
}

const getters = {
    item: state => state.item,
    loading: state => state.loading
};

const actions = {
    store({ commit, state, dispatch }) {
        commit('setLoading', true);
        return new Promise((resolve, reject) => {
            Employee.store(state.item)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
                .finally(function () {
                    commit('setLoading', false)
                })
        })
    },
    setOrganization({ commit }, value) {
        commit('setOrganization', value)
    },
    setRole({ commit }, value) {
        commit('setRole', value)
    },
    setFirstName({ commit }, value) {
        commit('setFirstName', value)
    },
    setLastName({ commit }, value) {
        commit('setLastName', value)
    },
    resetState({ commit }) {
        commit('resetState')
    },
    resetItem({ commit }) {
        let identity = Object.assign({}, identityItem);
        commit('setItem', identity);
    }
};

const mutations = {
    setOrganization(state, value) {
        state.item.organization = value
    },
    setRole(state, value) {
        state.item.role = value
    },
    setFirstName(state, value) {
        state.item.firstName = value
    },
    setLastName(state, value) {
        state.item.lastName = value
    },
    setLoading(state, loading) {
        state.loading = loading
    },
    resetState(state) {
        state = Object.assign({}, initialState())
    }
}

export default {
    namespaced: true,
    state: initialState,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/Employee.js